import * as React from 'react';
import {
    DataGridPro,
    LicenseInfo,
    huHU,
    GridToolbar,
} from '@mui/x-data-grid-pro';
import Box from "@mui/material/Box";


const DinoDataGrid = ({rows, columns}) => {
    LicenseInfo.setLicenseKey(
        '93593b80f086b75ea9cb82344f4fa361T1JERVI6NDA0NzEsRVhQSVJZPTE2Nzk4NDM2MTEwMDAsS0VZVkVSU0lPTj0x',
    );

    return <Box sx={{height: '70vh', width: '100%'}}>
        <DataGridPro
            components={{ Toolbar: GridToolbar }}
            disableSelectionOnClick={true}
            rows={rows}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            localeText={huHU.components.MuiDataGrid.defaultProps.localeText}
        />
    </Box>
}

export default DinoDataGrid